import CueBackdrop from '../Captions/Constants/CueBackdrop';
import CueColour   from '../Captions/Constants/CueColour';
import CueFont     from '../Captions/Constants/CueFont';
import CueSize     from '../Captions/Constants/CueSize';

import IConfigCaptions from './Interfaces/IConfigCaptions';

class ConfigCaptions implements IConfigCaptions {
    public enable: boolean = false;
    public cueBackdrop: CueBackdrop = CueBackdrop.DEFAULT;
    public cueColour: CueColour = CueColour.DEFAULT;
    public cueFont: CueFont = CueFont.DEFAULT;
    public cueSize: CueSize = CueSize.M;

    constructor() {
        Object.seal(this);
    }
}

export default ConfigCaptions;